﻿import { makeObservable } from "mobx";
import type { GetEnvironmentAndCountryInfoResponse } from "../../network/responses/GetEnvironmentAndCountryInfoResponse";
import { CountryInfoModel } from "../../../OpenApi/api";
import { CountryModelExtended } from "./CountryModelExtended";
import { IResourcesStore } from "../../resources/ResourcesStore";

export interface ICountryStore {
	currentCountry: CountryModelExtended | null;
	allCountries: CountryModelExtended[];
	defaultCountryAboutBox: CountryModelExtended | null;
}

export class CountryStore implements ICountryStore {
	public currentCountry: CountryModelExtended | null = null;
	public allCountries: CountryModelExtended[] = [];
	public defaultCountryAboutBox: CountryModelExtended | null;

	constructor(getEnvironmentAndCountryInfoResponse: GetEnvironmentAndCountryInfoResponse, countryInfo: CountryInfoModel, resourcesStore: IResourcesStore) {
		makeObservable(this);

		this.allCountries = countryInfo.countries.map(country => ({
			...country,
			translatedName: resourcesStore.resources[country.fullName] ?? country.fullName,
		}));

		//Set current country from the all countries, since the getEnvironmentAndCountryInfoResponse comes from POW3
		//And POW3 doesn't include all the data on tblCountry
		this.currentCountry = this.allCountries.find(c => c.abbreviation == getEnvironmentAndCountryInfoResponse.currentCountry?.abbreviation) ?? null;
		this.defaultCountryAboutBox = this.allCountries.find(c => c.abbreviation === countryInfo.defaultCountryAboutBox) ?? null;
	}
}
